import { placeReduxConstants } from '@/constants';

export const placeActions = {
  setHover,
  removeHover,
  setPlaceData,
};

function setHover(placeId) {
  return { type: placeReduxConstants.SET_HOVER, placeId };
}

function removeHover(placeId) {
  return { type: placeReduxConstants.REMOVE_HOVER, placeId };
}

function setPlaceData(place) {
  return { type: placeReduxConstants.SET_PLACE_DATA, place };
}
